import Modal from "react-modal";
import {X} from "react-feather";
import React from "react";

const ConfirmationModal = ({handleClose, handleConfirm, title, message, btnCancel = 'Cancel', btnConfirm = 'Yes', errorMessage = ''}) => {
    return (
        <Modal
            isOpen={true}
            className="sl-modal-content sl-max-modal"
            overlayClassName="sl-modal sl-block sl-rounded-md sl-bg-gray-900-opacity-50">

            <div className="sl-modal-body">
                <div
                    className="sl-modal-header sl-rounded-md sl-flex sl-justify-between sl-bg-gray-50 sl-text-gray-900 sl-px-6 sl-py-16 sl-border-bottom">
                    <div
                        className="title sl-font-semibold sl-text-lg sl-mr-auto sl-ml-0 sl-font">
                        {title}

                    </div>
                    <div className="sl-cursor-pointer sl-btn-link-gray sl-mr-0">
                        <X onClick={handleClose}/>
                    </div>
                </div>
                <div className="sl-modal-body">
                </div>
            </div>
            <div className="sl-modal-body">
                <div
                    className="sl-modal-body sl-max-h-185i sl-h-auto sl-px-6 sl-pb-0 sl-pt-24 sl-overflow-y-auto sl-customized-scrollbar sl-font"
                >
                    {message}
                    {errorMessage && (
                        <div className="sl-text-error-500 sl-mt-4 sl-font sl-text-sm">
                            {errorMessage}
                        </div>
                    )}
                </div>
            </div>


            <div className="sl-modal-footer sl-px-6 sl-py-32  sl-display-flex sl-flex-row sl-justify-space-between">

                <div
                    className="sl-flex sl-justify-end sl-gap-2-point-5
                             sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">
                    <button
                        onClick={handleClose}
                        className="sl-btn sl-btn-tertiary sl-btn-lg  sl-rounded-lg sl-text-md sl-pl-20 sl-pr-20 sl-font">
                        {btnCancel}
                    </button>
                </div>

                <div
                    className="sl-flex sl-justify-end sl-gap-2-point-5 sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">
                    <button
                        onClick={handleConfirm}
                        className="sl-btn sl-btn-primary sl-btn-lg  sl-rounded-lg sl-text-md sl-pl-20 sl-pr-20 sl-font ">
                        {btnConfirm}
                    </button>
                </div>

            </div>
        </Modal>
    );
}

export default ConfirmationModal;